import { sidebarActionTypes } from './Constants';

const initialState = {
	loading: false,
	userData: {
		books: [],
		groups: [],
		subjects: [],
		notificationsCount: 0,
	},
	expanded: true,
	countriesLoading: false,
	countries: [],
	selectedCountryCode: null,
	countryCode: null,
	country: {
		name: null,
	},
	loadingMadeList: false,
	madeList: [],
};

export default function signInReducer(state = initialState, action) {
	const { type, payload } = action;
	const {
		userData,
		status,
		countries,
		selectedCountryCode,
		countryCode,
		data,
		locale,
		country,
		theme,
		count = 0,
	} = payload || {};

	switch (type) {
		case sidebarActionTypes.GET_USER_DATA_REQUEST:
			return {
				...state,
				loading: true,
			};

		case sidebarActionTypes.GET_USER_DATA_SUCCESS:
			const { new_notifications_count, role_name, is_license_student } = userData || {};

			return {
				...state,
				userData: {
					...userData,
					notificationsCount: new_notifications_count,
					isLicensePlusUser: role_name === 'Plus' && is_license_student,
					isLicensePremiumUser: role_name === 'Premium' && is_license_student,
				},
				loading: false,
			};

		case sidebarActionTypes.GET_USER_DATA_ERROR:
			return {
				...state,
				loading: false,
			};

		case sidebarActionTypes.SET_EXPANDED_MENU:
			return {
				...state,
				expanded: status,
			};

		case sidebarActionTypes.CLEAR_USER_DATA:
			return initialState;

		case sidebarActionTypes.SET_NOTIFICATION_COUNT:
			return {
				...state,
				userData: {
					...state.userData,
					notificationsCount: count,
				},
			};

		case sidebarActionTypes.GET_COUNTRIES_REQUEST:
			return {
				...state,
				loading: true,
			};

		case sidebarActionTypes.GET_COUNTRIES_SUCCESS:
			return {
				...state,
				loading: false,
				countries,
			};

		case sidebarActionTypes.GET_COUNTRIES_ERROR:
			return {
				...state,
				loading: false,
			};

		case sidebarActionTypes.SET_COUNTRY_OPTION_CODE:
			return {
				...state,
				selectedCountryCode,
			};

		case sidebarActionTypes.SET_COUNTRY_OPTION:
			return {
				...state,
				countryCode,
			};

		case sidebarActionTypes.UPDATE_USER_LOCALE:
			return {
				...state,
				userData: { ...state.userData, locale },
			};

		case sidebarActionTypes.UPDATE_USER_THEME:
			return {
				...state,
				userData: {
					...state.userData,
					theme: { ...(state.userData.theme || {}), selected_theme: theme },
				},
			};

		case sidebarActionTypes.SET_COUNTRY:
			return {
				...state,
				country,
			};

		case sidebarActionTypes.GET_MENU_MADE_LISTS_REQUEST:
			return {
				...state,
				loadingMadeList: true,
			};

		case sidebarActionTypes.GET_MENU_MADE_LISTS_SUCCESS:
			return {
				...state,
				loadingMadeList: false,
				madeList: data,
			};

		case sidebarActionTypes.GET_MENU_MADE_LISTS_ERROR:
			return {
				...state,
				loadingMadeList: false,
			};

		default:
			return state;
	}
}
